(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fk-product-media-simple"] && !Shopify.designMode) return;
  try {
    function initializeFkProductCarousels(root = document) {
    root.querySelectorAll('[data-fk-product-media-simple]').forEach((carousel) => {
      if (carousel.dataset.carouselInitialized === 'true') return;

      const list = carousel.querySelector('.fk-product-media-simple__list');
      const slides = Array.from(carousel.querySelectorAll('.fk-product-media-simple__item'));
      const previous = carousel.querySelector('[data-carousel-previous]');
      const next = carousel.querySelector('[data-carousel-next]');
      const current = carousel.querySelector('[data-carousel-current]');

      if (!list || slides.length < 2 || !previous || !next || !current) return;

      carousel.dataset.carouselInitialized = 'true';
      let activeIndex = 0;

      const updateControls = () => {
        current.textContent = String(activeIndex + 1);
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === slides.length - 1;
      };

      const goToSlide = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        const firstSlideOffset = slides[0].offsetLeft;
        list.scrollTo({ left: slides[activeIndex].offsetLeft - firstSlideOffset, behavior: 'smooth' });
        updateControls();
      };

      previous.addEventListener('click', () => goToSlide(activeIndex - 1));
      next.addEventListener('click', () => goToSlide(activeIndex + 1));

      let scrollFrame;
      list.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const listLeft = list.getBoundingClientRect().left;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - listLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          activeIndex = closestIndex;
          updateControls();
        });
      }, { passive: true });

      updateControls();
    });
  }

  initializeFkProductCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeFkProductCarousels(event.target));
  } catch(e) { console.error(e); }
})();

})();
